import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  insertFechaBloqueada,
  getFechasBloqueadas,
  updateFechaBloqueada,
  deleteFechaBloqueada,
  getFechasBloqueadasProvincia,
  updateFechaBloqueadaProvincia,
  deleteFechasBloqueadasProvincias,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_FECHAS_BLOQUEADAS() {
  try {
    const fechasBloqueadasData = yield call(getFechasBloqueadas)
    if (fechasBloqueadasData.ok) {
      yield put({
        type: actions.FECHA_BLOQUEADA_LOAD_SUCCEEDED,
        payload: fechasBloqueadasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas bloqueadas')
      put({
        type: actions.FECHA_BLOQUEADA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_BLOQUEADA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_FECHA_BLOQUEADA(action) {
  try {
    const fechaBloqueadaObj = yield call(insertFechaBloqueada, action.payload)
    if (fechaBloqueadaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha bloqueada creada correctamente')
      yield put({
        type: actions.FECHA_BLOQUEADA_INSERT_SUCCEEDED,
        payload: fechaBloqueadaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear fecha bloqueada')
      yield put({
        type: actions.FECHA_BLOQUEADA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear fecha no entrega')
    yield all([
      put({
        type: actions.FECHA_BLOQUEADA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_BLOQUEADA(action) {
  try {
    const fechaBloqueadaObj = yield call(updateFechaBloqueada, action.payload)
    if (fechaBloqueadaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha bloqueada modificada correctamente')
      yield put({
        type: actions.FECHA_BLOQUEADA_UPDATE_SUCCEEDED,
        payload: fechaBloqueadaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha bloqueada')
      yield put({
        type: actions.FECHA_BLOQUEADA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha no entrega')
    yield all([
      put({
        type: actions.FECHA_BLOQUEADA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FECHA_BLOQUEADA(action) {
  try {
    const fechaBloqueadaResult = yield call(deleteFechaBloqueada, action.payload)
    if (fechaBloqueadaResult.ok) {
      putMessage(messageType.SUCCESS, 'Fecha Bloqueada eliminada correctamente')
      yield put({
        type: actions.FECHA_BLOQUEADA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Fecha Bloqueada')
      yield put({
        type: actions.FECHA_BLOQUEADA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Fecha Bloqueada')
    yield all([
      put({
        type: actions.FECHA_BLOQUEADA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FECHAS_BLOQUEADAS_PROVINCIA(action) {
  try {
    const fechasBloqueadasData = yield call(getFechasBloqueadasProvincia, action.payload)
    if (fechasBloqueadasData.ok) {
      yield put({
        type: actions.FECHA_BLOQUEADA_PROVINCIA_LOAD_SUCCEEDED,
        payload: fechasBloqueadasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas bloqueadas provincia')
      put({
        type: actions.FECHA_BLOQUEADA_PROVINCIA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_BLOQUEADA_PROVINCIA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_BLOQUEADA_PROVINCIA(action) {
  try {
    const fechaBloqueadaProvinciaObj = yield call(updateFechaBloqueadaProvincia, action.payload)
    if (fechaBloqueadaProvinciaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha bloqueada provincia modificada correctamente')
      yield put({
        type: actions.FECHA_BLOQUEADA_PROVINCIA_UPDATE_SUCCEEDED,
        payload: fechaBloqueadaProvinciaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha bloqueada provincia')
      yield put({
        type: actions.FECHA_BLOQUEADA_PROVINCIA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha bloqueada provincia')
    yield all([
      put({
        type: actions.FECHA_BLOQUEADA_PROVINCIA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FECHAS_BLOQUEADAS_PROVINCIAS(action) {
  try {
    const fechaBloqueadasProvinciaResult = yield call(
      deleteFechasBloqueadasProvincias,
      action.payload,
    )
    if (fechaBloqueadasProvinciaResult.ok) {
      putMessage(messageType.SUCCESS, 'Fecha bloqueada provincia modificada correctamente')
      yield put({
        type: actions.FECHA_BLOQUEADA_PROVINCIA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha bloqueada provincia')
      yield put({
        type: actions.FECHA_BLOQUEADA_PROVINCIA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha bloqueada provincia')
    yield all([
      put({
        type: actions.FECHA_BLOQUEADA_PROVINCIA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FECHA_BLOQUEADA_LOAD_REQUESTED, GET_FECHAS_BLOQUEADAS),
    takeEvery(actions.FECHA_BLOQUEADA_INSERT_REQUESTED, INSERT_FECHA_BLOQUEADA),
    takeEvery(actions.FECHA_BLOQUEADA_UPDATE_REQUESTED, UPDATE_FECHA_BLOQUEADA),
    takeEvery(actions.FECHA_BLOQUEADA_DELETE_REQUESTED, DELETE_FECHA_BLOQUEADA),
    takeEvery(actions.FECHA_BLOQUEADA_PROVINCIA_LOAD_REQUESTED, GET_FECHAS_BLOQUEADAS_PROVINCIA),
    takeEvery(actions.FECHA_BLOQUEADA_PROVINCIA_UPDATE_REQUESTED, UPDATE_FECHA_BLOQUEADA_PROVINCIA),
    takeEvery(
      actions.FECHA_BLOQUEADA_PROVINCIA_DELETE_REQUESTED,
      DELETE_FECHAS_BLOQUEADAS_PROVINCIAS,
    ),
  ])
}
